import { zodResolver } from '@hookform/resolvers/zod';
import { customerInfoSchema } from './schemas';

export const customerInfoResolver = zodResolver(customerInfoSchema);
